import { Link, useLocation } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

export default function Header({ config }) {
  const location = useLocation();
  const site = config?.site || {};
  const nav = config?.navigation || [];

  return (
    <header className="app-header">
      <Link to="/" className="app-header__brand">
        <span className="app-header__logo">
          <img
            src={`${import.meta.env.BASE_URL}NFDIxCS_Logo2024_deepblue_crop.png`}
            alt="NFDIxCS"
            className="app-header__logo-img"
          />
        </span>
        <span className="app-header__titles">
          <span className="app-header__title">{site.title || 'Research Artifacts'}</span>
          {site.subtitle && <span className="app-header__subtitle">{site.subtitle}</span>}
        </span>
      </Link>

      <nav className="app-header__nav">
        {nav.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`app-header__link ${location.pathname === item.path ? 'app-header__link--active' : ''}`}
          >
            {item.label}
          </Link>
        ))}
      </nav>

      <ThemeToggle />
    </header>
  );
}
